import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { LESSON_STATUS } from '@yandex-int/k-common';

import { ClessonsStoreState } from './typings';

const initialState: ClessonsStoreState = {
    clessonStatuses: {},
};

const slice = createSlice({
    name: 'CLESSONS',
    initialState: initialState,
    reducers: {
        // Параметры нужны для саги
        /* eslint-disable @typescript-eslint/no-unused-vars */
        getClessonStatusesRequest: (
            state: ClessonsStoreState,
            action: PayloadAction<{
                clessonIds: number[];
            }>
        ) => {},

        getClessonStatusesSuccess: (
            state: ClessonsStoreState,
            action: PayloadAction<{
                clessonStatuses: Record<number, LESSON_STATUS | null>;
            }>
        ) => {
            Object.assign(state.clessonStatuses, action.payload.clessonStatuses);
        },
        /* eslint-enable @typescript-eslint/no-unused-vars */
    },
});

export const clessonsActions = slice.actions;
export const clessonsReducer = slice.reducer;
